import * as types from './constants';

// Get Shipping Code Random
export const getShippingCodeRandomRequest = data => (
  { type: types.GET_SHIPPING_CODE_RANDOM_REQUEST, payload: data }
);

export const getShippingCodeRandomDone = data => (
  { type: types.GET_SHIPPING_CODE_RANDOM_DONE, payload: data }
);

export const getShippingCodeRandomFailed = errors => (
  { type: types.GET_SHIPPING_CODE_RANDOM_FAILED, payload: errors }
);